<comment>
ボトムメニュー
</comment>

<template>
  <div class="bottom-menu">
    <div class="bottom-menu__frame-btns">
      <button class="bottom-menu__btn-top" @click="goToTop()"><img src="@/assets/image/btn_top.png" alt="戻る"></button>
      <div class="bottom-menu__btn-parent bottom-menu__btn-parent--grade" :class="{active:showGradeList}">
        <button class="bottom-menu__btn-child" @mousedown.stop @click="toggleGradeList()">グレード</button>
      </div>
    </div>
    <div class="bottom-menu__frame-text">
      <p class="bottom-menu__caption" v-html="gradeCaption.split('\n').join('<br>')"></p>
    </div>
    <gradeList></gradeList>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import gradeList from './gradeList'

export default {
  name: 'bottomMenu',
  components: {
    gradeList
  },
  computed: {
    ...mapState([
      'showGradeList',
    ]),
    ...mapGetters([
      'gradeCaption',
    ]),
  },
  methods: {
    ...mapActions([
      'displayGradeList'
    ]),
    //トップへ戻るボタンのクリックイベント
    goToTop: function(){
      window.open('', '_self').close();//自身を閉じる
    },
    toggleGradeList: function(){
      this.displayGradeList(!this.showGradeList);
    }
  },
}
</script>

<style lang="scss" scoped>
.bottom-menu{
  //height: 59px;
  height: 60px;
  background: #c8c6c3;
  display: flex;
  position: relative;
  @include size_s(){
    height: 44px;
  }
  &__frame-btns{
    padding-left: 190px;
    position: relative;
    // width: 680px;
    // min-width: 680px;
    width: 50%;
    min-width: 50%;
    max-width: 50%;
    box-sizing: border-box;
  }
  &__frame-text{
    // width: 680px;
    // min-width: 680px;
    height: 100%;
    overflow: hidden;
    width: 50%;
    min-width: 50%;
    max-width: 50%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  &__btn-top{
    position: absolute;
    left: 0;
    bottom: 0;
    appearance: none;
    border: none;
    line-height: 0;
    background: none;
    cursor: pointer;
    width: 190px;
    img{
      width: 100%;
      position:relative;//bottonクリック時IE11でずれるのを防止
    }
    @include size_s(){
      width: 142px;
    }
  }
  &__btn-parent{
    //margin-top: -1px;
    background-repeat: no-repeat;
    background-position: 0px 10px;
    background-size: 174px auto;
    width: 174px;
    height: 50px;
    padding-top: 10px;
    box-sizing: border-box;
    // background-color: pink;
    &.active{
      background-position: 0px -100px;
      @include size_s(){
        background-position: 0 -75px;
      }
    }
    &--grade{
      background-image:url(../assets/image/menu_tab.png);
      position: absolute;
      // left: 317px;
      right: 189px;
      @include size_s(){
        right: 140px;
      }
      top: 0;
      z-index: 1;
    }
    @include size_s(){
      margin-top: 0;
      width: 130px;
      height: 30+7px;
      background-position: 0px 7px;
      background-size: 130px auto;
      padding-top: 7px;
    }
  }
  &__btn-child{
    display: block;
    appearance: none;
    border: none;
    cursor: pointer;
    background: none;
    width: 100%;
    height: 100%;
    overflow: hidden;
    text-indent: 100%;
    overflow: hidden;
    text-align: left;
    white-space: nowrap;
    
    //test test test test test test
    // background: yellow;
    // opacity: 0.5;

  }
  &__caption{
    // margin-top: 10px;
    padding: 0 10px;
    height: 40px;
    border-left: #b9b7b3 1px solid;
    font-size: 0.992rem;
    color: #d62c2c;
    @include size_s(){
      height: 32px;
      font-size: 0.95rem;
      line-height: 1.3;
    }
  }
}

</style>